export default {
    name: 'Data Analysis',
    type: 'template',
    preview: 'https://cdn.affine.pro/templates/cover/data-analysis.png',
    assets: {
        'h3n8VMwxAvsSBVIu7zElTaEzsLJY6F6mGPK6Zym3cBQ=': 'https://cdn.affine.pro/templates/assets/h3n8VMwxAvsSBVIu7zElTaEzsLJY6F6mGPK6Zym3cBQ=.png',
    },
    content: {
        type: 'page',
        meta: {
            id: 'page:m_LVk8j2Fz',
            title: '',
            createDate: 1702622215481,
            tags: [],
        },
        blocks: {
            type: 'block',
            id: 'block:V51HC9f140',
            flavour: 'affine:page',
            props: {
                title: {
                    '$blocksuite:internal:text$': true,
                    delta: [],
                },
            },
            children: [
                {
                    type: 'block',
                    id: 'block:sNK1yLcZhO',
                    flavour: 'affine:surface',
                    props: {
                        elements: {
                            c6_y8ytVzO: {
                                type: 'shape',
                                xywh: '[3397.8937501737487,1503.7230387314412,115.16906082836704,166.5998176036096]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0.1,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'c6_y8ytVzO',
                                index: 'b04',
                                seed: 791799079,
                                color: '--affine-palette-line-black',
                            },
                            '5-_fqgg8D0': {
                                type: 'shape',
                                xywh: '[3591.6118063895638,1361.905537589504,115.16906082836704,308.41731819363895]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0.1,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '5-_fqgg8D0',
                                index: 'b05',
                                seed: 358258108,
                                color: '--affine-palette-line-black',
                            },
                            '1GXkFONwJS': {
                                type: 'shape',
                                xywh: '[3785.3298626053784,1229.0793103937567,115.16906082836704,441.2435447128246]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0.1,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '1GXkFONwJS',
                                index: 'b06',
                                seed: 261815659,
                                color: '--affine-palette-line-black',
                            },
                            '9pM0CTjfBu': {
                                type: 'shape',
                                xywh: '[3979.047918821194,1096.9361052346371,115.16906082836704,573.3867492533714]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0.1,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '9pM0CTjfBu',
                                index: 'b07',
                                seed: 206411053,
                                color: '--affine-palette-line-black',
                            },
                            zEZKKUJptW: {
                                type: 'text',
                                xywh: '[3422.978280587932,1700.400210580944,65,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '2020',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:BebasNeue',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'zEZKKUJptW',
                                index: 'b08',
                                seed: 1635061957,
                            },
                            PDIALmWZOI: {
                                type: 'text',
                                xywh: '[3616.6963368037473,1700.400210580944,65,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '2021',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:BebasNeue',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'PDIALmWZOI',
                                index: 'b09',
                                seed: 628646800,
                            },
                            uwmbQEZGAz: {
                                type: 'text',
                                xywh: '[3810.4143930195623,1700.400210580944,65,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '2022',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:BebasNeue',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'uwmbQEZGAz',
                                index: 'b0A',
                                seed: 1568703027,
                            },
                            LoLPB9d2wl: {
                                type: 'text',
                                xywh: '[4004.1324492353774,1700.400210580944,65,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '2023',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:BebasNeue',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'LoLPB9d2wl',
                                index: 'b0B',
                                seed: 275494740,
                            },
                            h48izQDwKn: {
                                type: 'text',
                                xywh: '[2773.051946781119,1078.2975205814919,539,96]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Supporting Data',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 64,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'h48izQDwKn',
                                index: 'b0C',
                                seed: 1284143478,
                            },
                            VwZCG18HYh: {
                                type: 'text',
                                xywh: '[2773.051946781119,1225.0506779931497,585.9470917571332,87]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Place brief results & impact data here. It should help viewers more quickly understand the data importance.',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Inter',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'VwZCG18HYh',
                                index: 'b0D',
                                seed: 87630515,
                                hasMaxWidth: true,
                            },
                            '3c8uV_3yjW': {
                                type: 'text',
                                xywh: '[3229.260224372117,1700.400210580944,65,48]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '2019',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:BebasNeue',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '3c8uV_3yjW',
                                index: 'b0E',
                                seed: 1402713908,
                            },
                            'rZWEQ-SOkt': {
                                type: 'shape',
                                xywh: '[3204.1756939579336,1593.6618527848755,115.16906082836704,76.66100355017534]',
                                rotate: 0,
                                shapeType: 'rect',
                                shapeStyle: 'General',
                                radius: 0.1,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'rZWEQ-SOkt',
                                index: 'b0F',
                                seed: 1648915049,
                                color: '--affine-palette-line-black',
                            },
                            i85T9hsDWj: {
                                type: 'shape',
                                xywh: '[4610.369742655374,1457.5907923099267,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'i85T9hsDWj',
                                index: 'b1x',
                                seed: 1344777050,
                                color: '--affine-palette-line-black',
                            },
                            wS4mwW71ol: {
                                type: 'shape',
                                xywh: '[4771.274910109951,1064.3900083088479,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'wS4mwW71ol',
                                index: 'b1w',
                                seed: 1306727173,
                                color: '--affine-palette-line-black',
                            },
                            MqRr3l2cS_: {
                                type: 'shape',
                                xywh: '[4932.180077564528,1250.1253230607085,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'MqRr3l2cS_',
                                index: 'b1v',
                                seed: 274179867,
                                color: '--affine-palette-line-black',
                            },
                            _KDVZJ6KO0: {
                                type: 'shape',
                                xywh: '[5139.419126197557,1320.2220024188518,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: '_KDVZJ6KO0',
                                index: 'b1u',
                                seed: 1253657646,
                                color: '--affine-palette-line-black',
                            },
                            AvrTqK47E0: {
                                type: 'shape',
                                xywh: '[5375.032549866165,1277.2569085371215,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'AvrTqK47E0',
                                index: 'b1t',
                                seed: 64093362,
                                color: '--affine-palette-line-black',
                            },
                            VdfwWRxtXR: {
                                type: 'shape',
                                xywh: '[5535.937717320742,1567.9336923576252,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'VdfwWRxtXR',
                                index: 'b1s',
                                seed: 184708484,
                                color: '--affine-palette-line-black',
                            },
                            'IEJj9-BdLU': {
                                type: 'shape',
                                xywh: '[5696.84288477532,1567.9336923576252,36.34643946415842,36.34643946415842]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 10,
                                strokeColor: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                id: 'IEJj9-BdLU',
                                index: 'b1r',
                                seed: 1832389835,
                                color: '--affine-palette-line-black',
                            },
                            uG5xLRTjp_: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'i85T9hsDWj',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'wS4mwW71ol',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'uG5xLRTjp_',
                                index: 'b1f',
                                seed: 1438288398,
                                rearEndpointStyle: 'None',
                                xywh: '[3536.433018669503,1694.8315767726597,124.55872799041936,393.200784001079]',
                            },
                            v0tQn2FVYC: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'wS4mwW71ol',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'MqRr3l2cS_',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'v0tQn2FVYC',
                                index: 'b1g',
                                seed: 64616915,
                                rearEndpointStyle: 'None',
                                xywh: '[3697.3381861240805,1694.8315767726594,124.5587279904189,185.73531475186087]',
                            },
                            Di36MA78NN: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'MqRr3l2cS_',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: '_KDVZJ6KO0',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'Di36MA78NN',
                                index: 'b1h',
                                seed: 267711923,
                                rearEndpointStyle: 'None',
                            },
                            '-MNy2gA7St': {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: '_KDVZJ6KO0',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'AvrTqK47E0',
                                    position: [0, 0.5000000000000021],
                                },
                                id: '-MNy2gA7St',
                                index: 'b1i',
                                seed: 1131766686,
                                rearEndpointStyle: 'None',
                            },
                            vjwYnOYikD: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'AvrTqK47E0',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'VdfwWRxtXR',
                                    position: [0, 0.499999999999996],
                                },
                                id: 'vjwYnOYikD',
                                index: 'b1j',
                                seed: 579119068,
                                rearEndpointStyle: 'None',
                            },
                            t20LAcXM0p: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-tangerine',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'VdfwWRxtXR',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'IEJj9-BdLU',
                                    position: [0, 0.499999999999996],
                                },
                                id: 't20LAcXM0p',
                                index: 'b1k',
                                seed: 1008579259,
                                rearEndpointStyle: 'None',
                            },
                            f2p0001uIs: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'i85T9hsDWj',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'wS4mwW71ol',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'f2p0001uIs',
                                index: 'b1l',
                                seed: 1760844667,
                                rearEndpointStyle: 'None',
                            },
                            '435uAEsilC': {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'wS4mwW71ol',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'MqRr3l2cS_',
                                    position: [0, 0.5000000000000021],
                                },
                                id: '435uAEsilC',
                                index: 'b1m',
                                seed: 848079207,
                                rearEndpointStyle: 'None',
                                xywh: '[3697.3381861240805,1694.8315767726594,124.5587279904189,185.73531475186087]',
                            },
                            j7LfA7NdDg: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'MqRr3l2cS_',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: '_KDVZJ6KO0',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'j7LfA7NdDg',
                                index: 'b1n',
                                seed: 2118726728,
                                rearEndpointStyle: 'None',
                                xywh: '[3858.2433535786577,1880.56689152452,170.89260916886997,70.09667935814377]',
                            },
                            yWKGbh9DFK: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: '_KDVZJ6KO0',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'AvrTqK47E0',
                                    position: [0, 0.5000000000000021],
                                },
                                id: 'yWKGbh9DFK',
                                index: 'b1o',
                                seed: 291654331,
                                rearEndpointStyle: 'None',
                                xywh: '[4065.482402211686,1907.6984770009333,199.26698420445018,42.965093881730354]',
                            },
                            _iCD1ktcJ3: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'AvrTqK47E0',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'VdfwWRxtXR',
                                    position: [0, 0.499999999999996],
                                },
                                id: '_iCD1ktcJ3',
                                index: 'b1p',
                                seed: 1763910156,
                                rearEndpointStyle: 'None',
                                xywh: '[4301.095825880295,1907.698477000933,124.55872799041845,290.6767838205037]',
                            },
                            W4a0263kQK: {
                                type: 'connector',
                                mode: 0,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-orange',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    id: 'VdfwWRxtXR',
                                    position: [1, 0.5],
                                },
                                target: {
                                    id: 'IEJj9-BdLU',
                                    position: [0, 0.499999999999996],
                                },
                                id: 'W4a0263kQK',
                                index: 'b1q',
                                seed: 1778567460,
                                rearEndpointStyle: 'None',
                                xywh: '[4462.000993334872,2198.3752608214368,124.55872799041936,1]',
                            },
                            '3B2P-HdVJD': {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.169739765633, 1048.2809603058824],
                                },
                                target: {
                                    position: [5733.187883008289, 1048.1975537905903],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: '3B2P-HdVJD',
                                index: 'b1R',
                                seed: 1203313525,
                                xywh: '[4627.173163450028,1048.2016512682676,1106.02,1]',
                            },
                            'LMk-woJ4-E': {
                                type: 'text',
                                xywh: '[4517.364486468254,1667.8551086762654,21.81485652389979,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '0',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'LMk-woJ4-E',
                                index: 'b1S',
                                seed: 271694160,
                            },
                            zrYMvbnIpK: {
                                type: 'text',
                                xywh: '[4505.567446887902,1561.356775342932,34.13018798012501,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '10',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'zrYMvbnIpK',
                                index: 'b1T',
                                seed: 48647386,
                            },
                            D6fphDeac6: {
                                type: 'text',
                                xywh: '[4499.765622755009,1454.8584420095985,40.04031239729277,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '20',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'D6fphDeac6',
                                index: 'b1U',
                                seed: 687133044,
                            },
                            'R-pa03VqHI': {
                                type: 'text',
                                xywh: '[4499.765622759201,1348.3601086762656,39.421451742529726,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '30',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'R-pa03VqHI',
                                index: 'b1V',
                                seed: 1447168504,
                            },
                            wicpA_aVo7: {
                                type: 'text',
                                xywh: '[4497.831681378775,1241.861775342932,41.8040719030283,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '40',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'wicpA_aVo7',
                                index: 'b1W',
                                seed: 552573628,
                            },
                            JPOqzYuv5C: {
                                type: 'text',
                                xywh: '[4498.79865207056,1028.8651086762652,40.999551576356154,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '60',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'JPOqzYuv5C',
                                index: 'b1X',
                                seed: 440926681,
                            },
                            U1g_D2TPyS: {
                                type: 'text',
                                xywh: '[4498.79865207056,1135.3634420095987,40.38069092159311,38.67882780969519]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '50',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.94306224775615,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'U1g_D2TPyS',
                                index: 'b1Y',
                                seed: 1694080700,
                            },
                            'PglzK7-gx8': {
                                type: 'text',
                                xywh: '[4747.384904598986,1706.8204706855217,84.12645048608704,41.57973989542233]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'item 1',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.943062247756124,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'PglzK7-gx8',
                                index: 'b1Z',
                                seed: 1022746071,
                            },
                            '9B0jVlxdLx': {
                                type: 'text',
                                xywh: '[4927.276857809187,1706.8204706855217,89.92827465754132,41.57973989542233]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'item 2',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.943062247756124,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '9B0jVlxdLx',
                                index: 'b1a',
                                seed: 437482538,
                            },
                            rKjwdIkNeP: {
                                type: 'text',
                                xywh: '[5112.970635151549,1706.8204706855217,89.92827465754132,41.57973989542233]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'item 3',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.943062247756124,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'rKjwdIkNeP',
                                index: 'b1b',
                                seed: 1749471389,
                            },
                            'gT-4sFhP3x': {
                                type: 'text',
                                xywh: '[5298.66441248081,1706.8204706855217,91.86221604802608,41.57973989542233]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'item 4',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.943062247756124,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'gT-4sFhP3x',
                                index: 'b1c',
                                seed: 836905351,
                            },
                            rPglyfceiH: {
                                type: 'text',
                                xywh: '[5486.292131194007,1706.8204706855217,90.8952453527837,41.57973989542233]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'item 5',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 30.943062247756124,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'rPglyfceiH',
                                index: 'b1d',
                                seed: 780869614,
                            },
                            'S2I-Ll5G6z': {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.152134149909, 1154.638426984745],
                                },
                                target: {
                                    position: [5733.170277392568, 1154.5550204694525],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'S2I-Ll5G6z',
                                index: 'b1e',
                                seed: 562989730,
                                xywh: '[4627.153163450029,1154.5516512682675,1106.0200000000004,1]',
                            },
                            TLQkXe2k6i: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.153141945715, 1260.9769343506796],
                                },
                                target: {
                                    position: [5733.171285188376, 1260.8935278353872],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'TLQkXe2k6i',
                                index: 'b1f',
                                seed: 23379453,
                                xywh: '[4627.153163450029,1260.8916512682677,1106.0200000000004,1]',
                            },
                            oxJleaRzPB: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.153141945713, 1367.2715303140023],
                                },
                                target: {
                                    position: [5733.171285188374, 1367.1881237987102],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'oxJleaRzPB',
                                index: 'b1g',
                                seed: 2141765566,
                                xywh: '[4627.153163450029,1367.1916512682674,1106.0200000000004,1]',
                            },
                            Ofyq2_h6Eg: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.153141945715, 1473.6462140682604],
                                },
                                target: {
                                    position: [5733.171285188374, 1473.5628075529673],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'Ofyq2_h6Eg',
                                index: 'b1h',
                                seed: 265717218,
                                xywh: '[4627.153163450029,1473.5616512682673,1106.0200000000004,1]',
                            },
                            j6sQ6jMAzp: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [4627.167409138024, 1579.9685555393962],
                                },
                                target: {
                                    position: [5733.185552380693, 1579.885149024104],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'j6sQ6jMAzp',
                                index: 'b1i',
                                seed: 815704705,
                                xywh: '[4627.163163450029,1579.8816512682674,1106.0100000000002,1]',
                            },
                            t4VBb86idl: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 4,
                                stroke: '--affine-palette-line-black',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    position: [4627.165588856708, 1686.270421595575],
                                },
                                target: {
                                    position: [5733.183732099367, 1686.187015080283],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 't4VBb86idl',
                                index: 'b1j',
                                seed: 394078032,
                                xywh: '[4627.163163450029,1686.1916512682674,1106.0199999999995,1]',
                            },
                            lyx7ZXgtMW: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        '3B2P-HdVJD': true,
                                        'S2I-Ll5G6z': true,
                                        TLQkXe2k6i: true,
                                        oxJleaRzPB: true,
                                        Ofyq2_h6Eg: true,
                                        j6sQ6jMAzp: true,
                                        t4VBb86idl: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Group 1',
                                        },
                                    ],
                                },
                                id: 'lyx7ZXgtMW',
                                index: 'b1S',
                                seed: 1528917,
                            },
                            '36AReS4o4Y': {
                                type: 'shape',
                                xywh: '[4457.826223436582,2177.0388998667804,517.3405504720579,517.3405504720579]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '36AReS4o4Y',
                                index: 'b1y',
                                seed: 1942982855,
                                color: '--affine-palette-line-black',
                            },
                            ltXTU_jFVm: {
                                type: 'shape',
                                xywh: '[4867.276530085858,2177.0388998667804,517.3405504720579,517.3405504720579]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-orange',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'ltXTU_jFVm',
                                index: 'b1z',
                                seed: 2095916862,
                                color: '--affine-palette-line-black',
                            },
                            'rFv6J7-bEm': {
                                type: 'shape',
                                xywh: '[5276.726836735134,2177.0388998667804,517.3405504720579,517.3405504720579]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'rFv6J7-bEm',
                                index: 'b20',
                                seed: 2051662826,
                                color: '--affine-palette-line-black',
                            },
                            TaCfMQE8WN: {
                                type: 'text',
                                xywh: '[4477.826223436582,2081.9841785658937,85.51995849609375,56]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Title',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 40,
                                fontFamily: 'blocksuite:surface:Poppins',
                                fontWeight: '600',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'TaCfMQE8WN',
                                index: 'b24',
                                seed: 382883616,
                            },
                            IWh_yOmIOX: {
                                type: 'text',
                                xywh: '[2796.1445247601528,2558.240428780935,47.207977294921875,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$2m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'IWh_yOmIOX',
                                index: 'b2Z',
                                seed: 513297780,
                            },
                            '2_TAbG0y71': {
                                type: 'text',
                                xywh: '[2796.00052756777,2476.3882571357053,47.35197448730469,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$3m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '2_TAbG0y71',
                                index: 'b2a',
                                seed: 1585532004,
                            },
                            '4B8CSO0Z4C': {
                                type: 'text',
                                xywh: '[2794.584527201559,2394.5360854904757,48.767974853515625,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$4m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '4B8CSO0Z4C',
                                index: 'b2b',
                                seed: 1226227730,
                            },
                            dL7mXYtmgs: {
                                type: 'text',
                                xywh: '[2795.6405269574184,2312.683913845245,47.71197509765625,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$5m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'dL7mXYtmgs',
                                index: 'b2c',
                                seed: 949199966,
                            },
                            RyP5d4eZJI: {
                                type: 'text',
                                xywh: '[2795.1605159710903,2230.8317422000155,48.191986083984375,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$6m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'RyP5d4eZJI',
                                index: 'b2d',
                                seed: 328501956,
                            },
                            VlC_nN4ctZ: {
                                type: 'text',
                                xywh: '[2797.5365230511684,2148.979570554786,45.81597900390625,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$7m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'VlC_nN4ctZ',
                                index: 'b2e',
                                seed: 2036463780,
                            },
                            q5_leyjHDp: {
                                type: 'text',
                                xywh: '[2794.9445278119106,2067.1273989095553,49,33]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$8m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'q5_leyjHDp',
                                index: 'b2f',
                                seed: 513387752,
                            },
                            Owkp5nYWoo: {
                                type: 'text',
                                xywh: '[2998.2520972779025,2761.8309582222328,58.12797546386719,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$10m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'Owkp5nYWoo',
                                index: 'b2g',
                                seed: 673216415,
                            },
                            '8NhVWJNeVO': {
                                type: 'text',
                                xywh: '[3138.39652721002,2761.8309582222328,63.5999755859375,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$20m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '8NhVWJNeVO',
                                index: 'b2h',
                                seed: 230923638,
                            },
                            f57BRkFtXy: {
                                type: 'text',
                                xywh: '[3283.5409571421364,2761.8309582222328,63.82366943359375,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$30m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24.030791930020357,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'f57BRkFtXy',
                                index: 'b2i',
                                seed: 969195576,
                            },
                            U5CuU2zYGw: {
                                type: 'text',
                                xywh: '[3427.685387074254,2761.8309582222328,65.15997314453125,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$40m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'U5CuU2zYGw',
                                index: 'b2j',
                                seed: 1095060202,
                            },
                            rPC_UHFHXs: {
                                type: 'text',
                                xywh: '[3573.8298170063713,2761.8309582222328,64.10397338867188,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$50m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'rPC_UHFHXs',
                                index: 'b2k',
                                seed: 439610053,
                            },
                            bmwpmmbHPZ: {
                                type: 'text',
                                xywh: '[3718.9742469384887,2761.8309582222328,64.583984375,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$60m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'bmwpmmbHPZ',
                                index: 'b2l',
                                seed: 201573806,
                            },
                            HBNcefNNcw: {
                                type: 'text',
                                xywh: '[2801.616524882223,2640.0926004261646,41.73597717285156,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '$1m',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'HBNcefNNcw',
                                index: 'b2m',
                                seed: 1526641817,
                            },
                            vHgwP5I9Uw: {
                                type: 'shape',
                                xywh: '[2921.6224560798214,2422.141754664387,125.7092756113222,125.70927561132221]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'vHgwP5I9Uw',
                                index: 'b2n',
                                seed: 915440576,
                                color: '--affine-palette-line-black',
                            },
                            jUDp_2Jj8V: {
                                type: 'shape',
                                xywh: '[3305.4843841173974,2342.2871179665917,125.7092756113222,125.70927561132221]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'jUDp_2Jj8V',
                                index: 'b2o',
                                seed: 646799509,
                                color: '--affine-palette-line-black',
                            },
                            'V_-Wuax_SI': {
                                type: 'shape',
                                xywh: '[3627.7686610861615,2214.7509345651824,171.48231647873936,171.48231647873942]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'V_-Wuax_SI',
                                index: 'b2p',
                                seed: 1306086331,
                                color: '--affine-palette-line-black',
                            },
                            'Xg_oWo2GR-': {
                                type: 'shape',
                                xywh: '[3667.7730214559874,2591.3252339433093,125.7092756113222,125.70927561132221]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'Xg_oWo2GR-',
                                index: 'b2q',
                                seed: 1918350130,
                                color: '--affine-palette-line-black',
                            },
                            mQgQLPcqNB: {
                                type: 'shape',
                                xywh: '[3378.1607170312923,2102.035078257145,171.48231647873936,171.48231647873942]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'mQgQLPcqNB',
                                index: 'b2r',
                                seed: 1323878626,
                                color: '--affine-palette-line-black',
                                text: {
                                    'affine:surface:text': true,
                                    delta: [],
                                },
                                fontFamily: 'blocksuite:surface:Inter',
                            },
                            YmQIobiNzx: {
                                type: 'shape',
                                xywh: '[3075.655305101491,2568.837450876309,90.18222154012594,90.182221540126]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'YmQIobiNzx',
                                index: 'b2s',
                                seed: 1850194341,
                                color: '--affine-palette-line-black',
                            },
                            FzQCiBSwDW: {
                                type: 'shape',
                                xywh: '[3431.193657512987,2392.3806612601848,125.7092756113222,125.70927561132221]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-red',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'FzQCiBSwDW',
                                index: 'b2t',
                                seed: 405047153,
                                color: '--affine-palette-line-black',
                            },
                            '3XIk-ed3W-': {
                                type: 'shape',
                                xywh: '[3153.2044762894807,2211.3296746957194,90.18222154012594,90.182221540126]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '3XIk-ed3W-',
                                index: 'b2u',
                                seed: 1022146453,
                                color: '--affine-palette-line-black',
                            },
                            'U-EnVCakgN': {
                                type: 'shape',
                                xywh: '[2994.3552108793688,2256.4207839545215,171.48231647873936,171.48231647873942]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-red',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'U-EnVCakgN',
                                index: 'b2v',
                                seed: 2020352953,
                                color: '--affine-palette-line-black',
                            },
                            RTQiCbyZ5F: {
                                type: 'shape',
                                xywh: '[3273.9604264124314,2498.584871894688,171.48231647873936,171.48231647873942]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'RTQiCbyZ5F',
                                index: 'b2w',
                                seed: 620330432,
                                color: '--affine-palette-line-black',
                            },
                            jkBH37jlcq: {
                                type: 'shape',
                                xywh: '[3585.750563174253,2482.2566128084363,90.18222154012594,90.182221540126]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'jkBH37jlcq',
                                index: 'b2x',
                                seed: 410606473,
                                color: '--affine-palette-line-black',
                            },
                            eZSOAqLsbI: {
                                type: 'shape',
                                xywh: '[3047.3317297885083,2142.6851257264516,90.18222154012594,90.182221540126]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-red',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'eZSOAqLsbI',
                                index: 'b2y',
                                seed: 1715204277,
                                color: '--affine-palette-line-black',
                            },
                            '3osOn0G19Y': {
                                type: 'shape',
                                xywh: '[3175.675147113066,2466.8005415245334,90.18222154012594,90.182221540126]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-line-yellow',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: '3osOn0G19Y',
                                index: 'b2z',
                                seed: 2124064769,
                                color: '--affine-palette-line-black',
                            },
                            CaSbW_RHtV: {
                                type: 'text',
                                xywh: '[3913.036830627853,2466.8005415245334,220,33]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Department Involved',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'CaSbW_RHtV',
                                index: 'b30',
                                seed: 1140501430,
                            },
                            '9aZgMx6HZJ': {
                                type: 'text',
                                xywh: '[3913.036830627853,2115.326544798877,199,33]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Chance of success',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '9aZgMx6HZJ',
                                index: 'b31',
                                seed: 1465355988,
                            },
                            Yhg8S2pfi7: {
                                type: 'shape',
                                xywh: '[3908.140419122659,2170.232905981963,216.00034506195928,216.00034506195925]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: false,
                                fillColor: '--affine-palette-transparent',
                                strokeWidth: 2,
                                strokeColor: '--affine-palette-line-black',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                id: 'Yhg8S2pfi7',
                                index: 'b32',
                                seed: 486668819,
                                color: '--affine-palette-line-black',
                            },
                            E2tTGyHpFj: {
                                type: 'shape',
                                xywh: '[3967.884941488727,2289.7219502396274,96.51130032982422,96.51130032982422]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: false,
                                fillColor: '--affine-palette-transparent',
                                strokeWidth: 2,
                                strokeColor: '--affine-palette-line-black',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                id: 'E2tTGyHpFj',
                                index: 'b33',
                                seed: 228709007,
                                color: '--affine-palette-line-black',
                            },
                            saILXjrRla: {
                                type: 'text',
                                xywh: '[3994.4766054475836,2327.9776004045398,43.327972412109375,20]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '>25%',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 16,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'saILXjrRla',
                                index: 'b34',
                                seed: 223838011,
                            },
                            MxIm_SWj4n: {
                                type: 'shape',
                                xywh: '[3936.4302899212084,2226.8126473543934,159.42060346486008,159.42060346486008]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: false,
                                fillColor: '--affine-palette-transparent',
                                strokeWidth: 2,
                                strokeColor: '--affine-palette-line-black',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                id: 'MxIm_SWj4n',
                                index: 'b35',
                                seed: 1565625787,
                                color: '--affine-palette-line-black',
                            },
                            '2BDd_DjRRF': {
                                type: 'text',
                                xywh: '[3986.284619363599,2256.6434687868514,59.711944580078125,20]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '25-50%',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 16,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '2BDd_DjRRF',
                                index: 'b36',
                                seed: 326267270,
                            },
                            '1hDwAycJUX': {
                                type: 'text',
                                xywh: '[3982.244618448072,2192.4850067928637,67.79194641113281,20]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: '50-100%',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 16,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '1hDwAycJUX',
                                index: 'b37',
                                seed: 1650177112,
                            },
                            fhob_y9gtC: {
                                type: 'shape',
                                xywh: '[3913.036830627853,2529.5985081808685,44.07805001549741,44.07805001549741]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-yellow',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-transparent',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'fhob_y9gtC',
                                index: 'b38',
                                seed: 1655487271,
                            },
                            V6uXPjDXmi: {
                                type: 'text',
                                xywh: '[3974.140591653639,2536.6375331886175,104.4239501953125,30]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Marketing',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'V6uXPjDXmi',
                                index: 'b39',
                                seed: 616322632,
                            },
                            qK6VsOo7Cm: {
                                type: 'shape',
                                xywh: '[3913.036830627853,2598.6854998449517,44.07805001549741,44.07805001549741]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-tangerine',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-transparent',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'qK6VsOo7Cm',
                                index: 'b3A',
                                seed: 1609408563,
                                color: '--affine-palette-line-black',
                            },
                            '1MPBCY2-Ay': {
                                type: 'text',
                                xywh: '[3974.1405916536382,2603.4745248527006,84,33]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Product',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: '1MPBCY2-Ay',
                                index: 'b3B',
                                seed: 280811991,
                            },
                            GUBNeZtjeu: {
                                type: 'shape',
                                xywh: '[3913.036830627853,2667.7724915090357,44.07805001549741,44.07805001549741]',
                                rotate: 0,
                                shapeType: 'ellipse',
                                shapeStyle: 'General',
                                radius: 0,
                                filled: true,
                                fillColor: '--affine-palette-shape-red',
                                strokeWidth: 4,
                                strokeColor: '--affine-palette-transparent',
                                strokeStyle: 'none',
                                roughness: 1.4,
                                id: 'GUBNeZtjeu',
                                index: 'b3C',
                                seed: 1159908116,
                                color: '--affine-palette-line-black',
                            },
                            MJPYjn49u1: {
                                type: 'text',
                                xywh: '[3974.1405916536382,2673.3115165167846,55,33]',
                                rotate: 0,
                                text: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Sales',
                                        },
                                    ],
                                },
                                color: '--affine-palette-line-black',
                                fontSize: 24,
                                fontFamily: 'blocksuite:surface:Satoshi',
                                fontWeight: '400',
                                fontStyle: 'normal',
                                textAlign: 'left',
                                id: 'MJPYjn49u1',
                                index: 'b3D',
                                seed: 1621442922,
                            },
                            We64ute95B: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-black',
                                strokeStyle: 'solid',
                                roughness: 1.4,
                                source: {
                                    position: [2909.4176265661513, 2736.419121580005],
                                },
                                target: {
                                    position: [3811.466843931026, 2736.569799995977],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'We64ute95B',
                                index: 'b3E',
                                seed: 1521325566,
                                xywh: '[2909.413163450029,2736.4216512682674,902.04,1]',
                            },
                            uG_WvHOyVh: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.4070846859804, 2654.5958521136927],
                                },
                                target: {
                                    position: [3811.4563020508563, 2654.7465305296646],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'uG_WvHOyVh',
                                index: 'b3F',
                                seed: 1831677614,
                                xywh: '[2909.403163450029,2654.5916512682675,902.0500000000002,1]',
                            },
                            '7qQxdfM3Nu': {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.4087762329214, 2572.743021994349],
                                },
                                target: {
                                    position: [3811.4579935977968, 2572.893700410321],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: '7qQxdfM3Nu',
                                index: 'b3G',
                                seed: 1102974444,
                                xywh: '[2909.413163450029,2572.7416512682676,902.0499999999997,1]',
                            },
                            '9QOwVlPj5q': {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.410129414337, 2490.893291478707],
                                },
                                target: {
                                    position: [3811.4593467792133, 2491.043969894679],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: '9QOwVlPj5q',
                                index: 'b3H',
                                seed: 539621401,
                                xywh: '[2909.413163450029,2490.891651268267,902.0499999999997,1]',
                            },
                            yBlfy25MDp: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.413221347584, 2409.044730336741],
                                },
                                target: {
                                    position: [3811.4624387124586, 2409.195408752713],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'yBlfy25MDp',
                                index: 'b3I',
                                seed: 362018792,
                                xywh: '[2909.413163450029,2409.0416512682673,902.0499999999997,1]',
                            },
                            tM3FpPx25R: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.407090891101, 2327.1930757855544],
                                },
                                target: {
                                    position: [3811.4563082559766, 2327.3437542015263],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'tM3FpPx25R',
                                index: 'b3J',
                                seed: 334413388,
                                xywh: '[2909.403163450029,2327.1916512682674,902.0500000000002,1]',
                            },
                            '8V3uSjDLZ-': {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.4069487013485, 2245.341649628514],
                                },
                                target: {
                                    position: [3811.4561660662243, 2245.492328044486],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: '8V3uSjDLZ-',
                                index: 'b3K',
                                seed: 798688083,
                                xywh: '[2909.403163450029,2245.3416512682675,902.0500000000002,1]',
                            },
                            muMJ4J4hKk: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    id: '',
                                    position: [2909.408366554494, 2163.4948481505653],
                                },
                                target: {
                                    position: [3811.4575839193712, 2163.6455265665372],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'muMJ4J4hKk',
                                index: 'b3L',
                                seed: 7776888,
                            },
                            uiipnxrqJg: {
                                type: 'connector',
                                mode: 1,
                                strokeWidth: 2,
                                stroke: '--affine-palette-line-grey',
                                strokeStyle: 'dash',
                                roughness: 1.4,
                                source: {
                                    position: [2909.418120508503, 2081.631465860281],
                                },
                                target: {
                                    position: [3811.46733787338, 2081.782144276253],
                                },
                                controllers: [],
                                frontEndpointStyle: 'None',
                                rearEndpointStyle: 'None',
                                id: 'uiipnxrqJg',
                                index: 'b3M',
                                seed: 173194315,
                                xywh: '[2909.413163450029,2081.6316512682674,902.0499999999997,1]',
                            },
                            '5tapz8apaA': {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        We64ute95B: true,
                                        IWh_yOmIOX: true,
                                        '2_TAbG0y71': true,
                                        '4B8CSO0Z4C': true,
                                        dL7mXYtmgs: true,
                                        RyP5d4eZJI: true,
                                        VlC_nN4ctZ: true,
                                        q5_leyjHDp: true,
                                        Owkp5nYWoo: true,
                                        '8NhVWJNeVO': true,
                                        f57BRkFtXy: true,
                                        U5CuU2zYGw: true,
                                        rPC_UHFHXs: true,
                                        bmwpmmbHPZ: true,
                                        uG_WvHOyVh: true,
                                        HBNcefNNcw: true,
                                        '7qQxdfM3Nu': true,
                                        '9QOwVlPj5q': true,
                                        yBlfy25MDp: true,
                                        tM3FpPx25R: true,
                                        '8V3uSjDLZ-': true,
                                        muMJ4J4hKk: true,
                                        uiipnxrqJg: true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Group 1',
                                        },
                                    ],
                                },
                                id: '5tapz8apaA',
                                index: 'b3N',
                                seed: 1138042771,
                            },
                            gSiyzJs40L: {
                                type: 'group',
                                children: {
                                    'affine:surface:ymap': true,
                                    json: {
                                        vHgwP5I9Uw: true,
                                        jUDp_2Jj8V: true,
                                        'V_-Wuax_SI': true,
                                        'Xg_oWo2GR-': true,
                                        mQgQLPcqNB: true,
                                        YmQIobiNzx: true,
                                        FzQCiBSwDW: true,
                                        '3XIk-ed3W-': true,
                                        'U-EnVCakgN': true,
                                        RTQiCbyZ5F: true,
                                        jkBH37jlcq: true,
                                        eZSOAqLsbI: true,
                                        '3osOn0G19Y': true,
                                    },
                                },
                                title: {
                                    'affine:surface:text': true,
                                    delta: [
                                        {
                                            insert: 'Bubbles',
                                        },
                                    ],
                                },
                                id: 'gSiyzJs40L',
                                index: 'b3O',
                                seed: 1351503666,
                            },
                        },
                    },
                    children: [
                        {
                            type: 'block',
                            id: 'block:HQxUOe6svX',
                            flavour: 'affine:frame',
                            props: {
                                title: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [
                                        {
                                            insert: 'Bar chart',
                                        },
                                    ],
                                },
                                background: '--affine-tag-yellow',
                                xywh: '[2632.6373939713108,923.9266478051833,1600,900]',
                                index: 'a5',
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:oB-VtTyFBT',
                            flavour: 'affine:frame',
                            props: {
                                title: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [
                                        {
                                            insert: 'Line chart',
                                        },
                                    ],
                                },
                                background: '--affine-tag-yellow',
                                xywh: '[4325.946805321888,923.9266478051833,1600,900]',
                                index: 'a6',
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:85AH8WQpah',
                            flavour: 'affine:frame',
                            props: {
                                title: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [
                                        {
                                            insert: 'User',
                                        },
                                    ],
                                },
                                background: '--affine-tag-yellow',
                                xywh: '[4325.946805321887,1959.5347939058884,1600,900]',
                                index: 'a7',
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:ZaSEIDjBIt',
                            flavour: 'affine:image',
                            props: {
                                caption: '',
                                sourceId: 'h3n8VMwxAvsSBVIu7zElTaEzsLJY6F6mGPK6Zym3cBQ=',
                                width: 0,
                                height: 0,
                                index: 'b21',
                                xywh: '[4503.985133032676,2386.7091751028092,98,98]',
                                rotate: 0,
                                size: -1,
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:772t5OTBiI',
                            flavour: 'affine:image',
                            props: {
                                caption: '',
                                sourceId: 'h3n8VMwxAvsSBVIu7zElTaEzsLJY6F6mGPK6Zym3cBQ=',
                                width: 0,
                                height: 0,
                                index: 'b22',
                                xywh: '[4915.108405394164,2386.7091751028092,98,98]',
                                rotate: 0,
                                size: -1,
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:0VgD8SXCde',
                            flavour: 'affine:image',
                            props: {
                                caption: '',
                                sourceId: 'h3n8VMwxAvsSBVIu7zElTaEzsLJY6F6mGPK6Zym3cBQ=',
                                width: 0,
                                height: 0,
                                index: 'b2X',
                                xywh: '[5326.231677755652,2386.7091751028092,98,98]',
                                rotate: 0,
                                size: -1,
                            },
                            children: [],
                        },
                        {
                            type: 'block',
                            id: 'block:-kCq8eMcH6',
                            flavour: 'affine:frame',
                            props: {
                                title: {
                                    '$blocksuite:internal:text$': true,
                                    delta: [
                                        {
                                            insert: 'Bubble chart',
                                        },
                                    ],
                                },
                                background: '--affine-tag-yellow',
                                xywh: '[2632.6373939713108,1959.5347939058884,1600,900]',
                                index: 'a9',
                            },
                            children: [],
                        },
                    ],
                },
            ],
        },
    },
};
//# sourceMappingURL=data-analysis.js.map